import { getSubstTerm } from '@/functions/expression'


export function createSuggestionsFromCclTextList(evaluatedCcl) {
  //console.log("createSuggestionsFromCclTextList")
  if (!evaluatedCcl) return null;

  //Read documents
  //let documentsArr = evaluatedCcl.documents
  //Read and Categorize expressions
  let expressionsArr = evaluatedCcl.expressions
  let bioArr = expressionsArr.filter(expr => {return expr.findingProcedureRoot === "Lab"})
  let imaArr = expressionsArr.filter(expr => {return expr.findingProcedureRoot === "Imaging"})
  let procedureArr = expressionsArr.filter(expr => {return expr.findingProcedureRoot === "General"})
  //let healthProArr = expressionsArr.filter(expr => {return expr.expressionType === "HealthProPrescription"})
  let healthProArr = expressionsArr.filter(expr => {return expr.healthProType !== "None"})
  //let medicArr = expressionsArr.filter(expr => {return expr.expressionType === "SubstanceAdministrationPrescription"})
  let medicArr = expressionsArr.filter(expr => {return expr.aggressorRootGroup === "Medic" || !expr.isMatched})

  //Create return object
  let ret = {}

  //BIOLOGY
  if (bioArr.length > 0) {
    //Eliminate duplicates
    const uniqueItems = new Set(bioArr.map(expr => expr.sctLabKey));
    const distinctArray = Array.from(uniqueItems).map(sctLabKey => {
      return bioArr.find(expr => expr.sctLabKey === sctLabKey);
    });
    //Create ButtonName
    let commonBioArr = []
    // let commonBioObj = {}
    for (let expr of distinctArray) {
      //Create term
      let nestingAggressorTerm = expr.sctNestingAggressorTerm
      nestingAggressorTerm = nestingAggressorTerm ? nestingAggressorTerm + " " : ""
      let fullAggressorTerm = nestingAggressorTerm + (expr.sctAggressorTerm || expr.sctFindingProcedureTerm)
      //Add term to expr
      expr.proxyTerm = fullAggressorTerm
      // //Group by siteRoot
      // let group = expr.sctSite;
      // if (!commonBioObj[group]) {
      //   commonBioObj[group] = {
      //     proxyKey: group,
      //     proxyTerm: expr.sctSiteTerm,
      //     proxyDetails: "",
      //     elements: [],
      //   };
      // }
      // commonBioObj[group].elements.push(expr);
      commonBioArr.push(expr);
    }
    ret.bio = commonBioArr;
    // ret.bio = Object.values(commonBioObj);
  }

  //IMAGING
  ret.imaging = imaArr

  // if (imaArr.length > 0) {
  //   //Group by sctFindingProcedureProxy
  //   let groupedImaArr = imaArr.reduce((result, expr) => {
  //     const group = expr.sctFindingProcedure;
  //     if (!result[group]) {
  //       let imagingTerm = expr.sctFindingProcedureTerm
  //       result[group] = result[group] || {
  //         "proxyKey": group,
  //         "proxyTerm" : imagingTerm,
  //         "proxyDetails" : "",
  //         "elements": [],
  //       }
  //     }
  //     result[group].elements.push(expr);
  //     return result;
  //   }, {});
  //   ret.imaging = Object.values(groupedImaArr)
  //   //Create ButtonName
  //   for (let exprGroup of ret.imaging) {
  //     let allSites
  //     for (let expr of exprGroup.elements) {
  //       let site = expr.sctSiteTerm
  //       allSites = allSites ? allSites + ", " + site : site
  //     }
  //     exprGroup.proxyDetails = allSites
  //   }
  // }

  //HEALTHPRO
  //Merge Procedures and HealthPro
  let healthProAndProcedureArr = [...healthProArr, ...procedureArr];

  if (healthProAndProcedureArr.length > 0) {
    //Group by healthProType
    let groupedHealthPro  = healthProAndProcedureArr.reduce((result, expr) => {
      const group = expr.healthProType;
      if (!result[group]) {
        result[group] = [];
      }
      result[group].push(expr);
      return result;
    }, {});
    // Filter
    let filteredHealthPro = [];
    for (let group in groupedHealthPro) {
      //Eliminate empty sctFindingProcedures
      let filteredArray = groupedHealthPro[group].filter(expr => expr.sctFindingProcedure !== '');
      if (filteredArray.length > 0) {
        //Eliminate duplicates
        const uniqueItems = new Set(filteredArray.map(expr => expr.sctFindingProcedure));
        const distinctArray = Array.from(uniqueItems).map(sctFindingProcedure => {
          return filteredArray.find(expr => expr.sctFindingProcedure === sctFindingProcedure);
        });
        let healthProObj = {
          "proxyKey": group,
          "proxyTerm" : group,
          "proxyDetails" : "",
          "elements": distinctArray,
        }
        filteredHealthPro.push(healthProObj);
      } else {
        //If there are no sctFindingProcedures, keep one healthPro expression
        let healthProObj = {
          "proxyKey": group,
          "proxyTerm" : group,
          "proxyDetails" : "",
          "elements": [groupedHealthPro[group][0]],
        }
        filteredHealthPro.push(healthProObj);
      }
    }
    ret.healthPro = filteredHealthPro
    //Create ButtonName
    for (let exprGroup of ret.healthPro) {
      let allProcedures
      for (let expr of exprGroup.elements) {
        let procedure = expr.sctFindingProcedureTerm
        allProcedures = allProcedures ? allProcedures + ", " + procedure : procedure
      }
      exprGroup.proxyDetails = allProcedures
    }
  }

  //DOCUMENTS
  // let detaileDocumentsArr = []
  // for (let doc of documentsArr) {
  //   let detailedDoc = {
  //     "proxyKey": "document",
  //     "proxyTerm" : doc.originalText,
  //     "proxyDetails" : "",
  //     "elements": [doc],
  //   }
  //   detaileDocumentsArr.push(detailedDoc)
  // }
  ret.documents = evaluatedCcl.documents  //detaileDocumentsArr

  //MEDICATION
  if (medicArr.length > 0) {
    //Group by sctSubstanceKey
    let groupedMedicArr = medicArr.reduce((result, expr) => {
      const group = expr.sctSubstanceKey || "unmatched";
      if (!result[group]) {
        //Only save 1 expression per substance-combination
        result[group] = result[group] || {
            "proxyKey": group,
            "proxyTerm" : "",
            "proxyDetails" : "",
            "elements": [expr],
          }
      }
      return result;
    }, {});
    ret.medic = Object.values(groupedMedicArr)
    //Create ButtonName
    for (let exprGroup of ret.medic) {
      let expr = exprGroup.elements[0]
      exprGroup.proxyTerm = getSubstTerm(expr) || expr.originalText
    }
  }
  //console.log(ret)
  return ret
}